export const formEl = [
  {
    label: "Group",
    value: 0,
    hasChildren: true,
  },
  {
    label: "Chọn một đáp án",
    value: 1,
  },
  {
    label: "Chọn nhiều đáp án",
    value: 2,
  },
  {
    label: "Chọn từ",
    value: 3,
  },
  {
    label: "Trả lời ngắn",
    value: 4,
  },
  {
    label: "Sắp xếp câu",
    value: 5,
  },
  {
    label: "Speaking (Ghi âm)",
    value: 6,
  },
  {
    label: "Đoạn văn",
    value: 7,
  },
  {
    label: "Nghe",
    value: 8,
    hasChildren: true,
  }
];
